import { useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoButton from 'eco-design/base/eco-button';
import JoinIcon from '../icons/JoinIcon';
import ShareIcon from '../icons/ShareIcon';
import GiftIcon from '../icons/GiftIcon';
import ReferButton from '../../ReferButton';

export default function StepsTab() {
    const [activeTab, setActiveTab] = useState<'referer' | 'referee'>('referer');
    const { t: s } = useLang('MyRewards');

    const refererSteps = [
        {
            icon: <JoinIcon />,
            title: s('referer.title1'),
            desc: s('referer.desc1'),
        },
        {
            icon: <ShareIcon />,
            title: s('referer.title2'),
            desc: s('referer.desc2'),
        },
        {
            icon: <GiftIcon />,
            title: s('referer.title3'),
            desc: s('referer.desc3'),
        },
    ];

    const refereeSteps = [
        {
            icon: <JoinIcon />,
            title: s('referee.title1'),
            desc: s('referee.desc1'),
        },
        {
            icon: <ShareIcon />,
            title: s('referee.title2'),
            desc: s('referee.desc2'),
        },
        {
            icon: <GiftIcon />,
            title: s('referee.title3'),
            desc: s('referee.desc3'),
        },
    ];

    const currentSteps = activeTab === 'referer' ? refererSteps : refereeSteps;

    return (
        <div className={`${styles.Tab}`}>
            <div className="sh-layout">
                <div className="tab-box">
                    <div className={`tab-item ${activeTab === 'referer' ? 'active' : ''}`} onClick={() => setActiveTab('referer')}>
                        {s('referer.tab_title')}
                    </div>
                    <div className={`tab-item ${activeTab === 'referee' ? 'active' : ''}`} onClick={() => setActiveTab('referee')}>
                        {s('referee.tab_title')}
                    </div>
                </div>

                <div className="steps-container">
                    {currentSteps.map((step, index) => (
                        <>
                            <div className="step-wrapper" key={index}>
                                <div className="step-item">
                                    <div className={`icon-circle icon-circle-${index}`}>{step.icon}</div>
                                    <div className="step-box">
                                        <div className="step-title">{step.title}</div>
                                        <div className="step-desc">{step.desc}</div>
                                    </div>
                                </div>
                            </div>
                            {index !== currentSteps.length - 1 && <div className="dashed-line"></div>}
                        </>
                    ))}
                </div>

                <div className="cta-wrapper">
                    <ReferButton lTheme="black" />
                </div>
            </div>
        </div>
    );
}
